module.exports = __webpack_public_path__ + "static/media/front-view.be376296.jpg";